import Vue from 'vue';
import list from '@/utils/list.js'
import believeService from '@/services/believes.js';

/**
For each Pk in list_preferences where Pk .WiGO = P.LoGO and P.WiGO = Pk.LoGO
    Set of Elements newE = elements(newS) union elements(scenario(Pk))
    If f_4.2_08(P, PknewE) Then
        f_6._01({P , Pk})
    End If
End For
 */
export const IsCohereService = new Vue({
    methods: {
        executeWorkflow (prefList, pref, beliefMode) {
            const wigoProperty = believeService.wigoProperty(beliefMode);
            const logoProperty = believeService.logoProperty(beliefMode);

            return prefList
                .filter(pk => {
                    return pk.id !== pref.id
                        && !this.isElementsIncludedInOtherList(pk.scenario.elements, pref.scenario.elements)
                        && pk[wigoProperty].length > 0
                        && pk[logoProperty].length > 0
                        && pref[wigoProperty].length > 0
                        && pref[logoProperty].length > 0
                        && pk[wigoProperty].map(w => w.id).sort().join('-') === pref[logoProperty].map(w => w.id).sort().join('-')
                        && pref[wigoProperty].map(w => w.id).sort().join('-') === pk[logoProperty].map(w => w.id).sort().join('-')
                        && list.same(pk.scenario.previousLevel, pref.scenario.previousLevel)
                })
                .map(pk => {
                    // creating addTodo
                    const todo = {
                        todo: "f_4_2_08",
                        piPref: pref,
                        pjPref: pk
                    };
                    console.log('IsCohereService.executeWorkflow identified a possible union', todo);
                    return todo;
                });
        },

        isElementsIncludedInOtherList(subList, mainList) {
            const subListIds = subList.map(element => element.id)
            const commonElements = mainList.filter(element => subListIds.indexOf(element.id) !== -1)
            return commonElements.length >= subListIds.length
        },

        isSubset(s, s1) {
            //s =si and s1=s
            let cp = 0;
            const sElements = s.elements.filter((elt) => elt.id !== "").map((elt) => elt.id);
            const s1Elements = s1.elements.filter((elt) => elt.id !== "").map((elt) => elt.id);

            for (let i = 0; i < sElements.length; i++) {
                if (s1Elements.includes(sElements[i])) {
                    cp++;
                }
            }
            return s1Elements.length - cp >= 0;
        },

        searchCoherentScenarios(preferenceswithnewSc, preferenceList, originalScenario, newSId, todoBack, beliefMode) {

          const possibleUnionsTodos = preferenceList
            .filter(pref => this.hasScenarioLevel(pref, originalScenario.level+1))
            .filter(pref => preferenceswithnewSc[0].groupId === pref.groupId)
            .filter(pref => pref.scenario.id !== newSId)
            .filter(pref => pref.scenario.extend === 'true')
            .filter(pref => this.isSubset(originalScenario,pref.scenario))
            .flatMap(pref => this.executeWorkflow(preferenceswithnewSc, pref, beliefMode));

          console.log('is coherent added this todos', possibleUnionsTodos);
          if(possibleUnionsTodos.length > 0 && todoBack) {
            possibleUnionsTodos.unshift(todoBack);
          }
          possibleUnionsTodos.forEach(todo => {
            this.$emit("addTodo", todo);
          });

        },

        hasScenarioLevel(preference, expectedLevel) {
          return preference.scenario.level === expectedLevel;
        },
    }
});
